module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Sport Space Gray + Black Closed.50da579d.png";